// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-quick-action-move-to-trash' )
export class AutomatorBuilderPublishQuickActionMoveToTrash extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				${ escapeHTML( __( 'Move to trash', 'uncanny-automator' ) ) }

				<uo-button
					slot="target"
					class="remove"
					size="small"
					color="transparent"

					href=${ UncannyAutomator._recipe.miscellaneous.url_trash_recipe.replace( /&amp;/g, '&' ) }

					needs-confirmation
					confirmation-content=${ escapeHTML( __( 'Are you sure you want to move this recipe to the trash?', 'uncanny-automator' ) ) }
					confirmation-button-label=${ escapeHTML( __( 'Move to trash', 'uncanny-automator' ) ) }
				>
					<uo-icon id="trash"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}